export function HTML({ cms }) {
  return (
    <section
      data-comp={HTML.displayName}
      id={`${HTML.Schema.key}-${cms.id || cms.cmsId || cms.tinaId}`}
    >
      <style>
        {`#${HTML.Schema.key}-${cms.id || cms.cmsId || cms.tinaId} {
            margin-top: ${cms.mobileSpacing}px;
          }
          @media(min-width: 1024px) {
            #${HTML.Schema.key}-${cms.id || cms.cmsId || cms.tinaId} {
              margin-top: ${cms.desktopSpacing}px;
            }
          }`}
      </style>
      {cms?.snippet && (
        <div
          className="m-auto block"
          dangerouslySetInnerHTML={{ __html: cms.snippet }}
        />
      )}
    </section>
  );
}

HTML.displayName = 'HTML';

HTML.Schema = {
  category: 'Modules',
  label: HTML.displayName,
  key: 'html',
  fields: [
    {
      component: 'number',
      name: 'mobileSpacing',
      label: 'Section Top Margin - Mobile',
      defaultValue: 60,
    },
    {
      component: 'number',
      name: 'desktopSpacing',
      label: 'Section Top Margin - Desktop',
      defaultValue: 80,
    },
    {
      name: 'snippet',
      label: 'HTML Snippet',
      component: 'html',
      description: 'Paste in code snippet here',
    },
  ],
};
